import { Injectable, InjectionToken } from '@angular/core'
import { CmsComponent, Converter } from '@spartacus/core'
import { CmsConverterService, defaultTextInput } from '../../../../services/cms-converter/cms-converter.service'
import { ConvertedComponentData, Image, TextInput } from '../../../types'

@Injectable({ providedIn: 'root' })
export class BubbleConverter extends CmsConverterService<BubbleData> {
  convertData (source: CmsComponent) {
    const formData = source?.otherProperties?.formData ?? {}
    const altText = formData.st_alt_text?.value
    const title = formData.st_image_title_text?.value
    const lazyLoad = formData.st_image_reference?.image_lazy_loading?.value
    const lazyLoadMobil = formData.st_image_mobile_reference?.image_lazy_loading?.value
    return {
      description: formData.st_description_text ?? defaultTextInput,
      headline: formData.st_headline ?? defaultTextInput,
      align: formData.st_box_position?.value?.identifier ?? 'left',
      pulse: formData.st_pulse_text?.value?.identifier ?? '',
      position: {
        top: formData.st_top_number?.value ?? 0,
        left: formData.st_left_number?.value ?? 0
      },
      imageDesktop: CmsConverterService.mapImage(formData.st_image_reference, lazyLoad, altText, title),
      imageMobile: CmsConverterService.mapImage(formData.st_image_mobile_reference, lazyLoadMobil, altText, title),
    }
  }
}

export const BUBBLE_CONVERTER_TOKEN = new InjectionToken<Converter<CmsComponent, BubbleData>>('BubbleConverter')

export interface BubbleData extends ConvertedComponentData {
  headline: TextInput;
  description: TextInput;
  align: string;
  imageDesktop: Image;
  imageMobile: Image;
  pulse: string;
  position: {
    top: number;
    left: number;
  };
}
